// src/pages/subscription/AddOnCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Add-on creation now
// happens through AddOnFormDialog (form-kit), opened from AddOnListPage's
// "Create Add-On" — see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AddOnCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/subscriptions/addons', { replace: true });
  }, [navigate]);
  return null;
};

export default AddOnCreatePage;
